'use strict';


var nodeMap = require('../node.map.js'),
    listItemRender = require('./list.item');


/* eslint no-useless-call: 0 */


module.exports = function ( value, callback ) {
    var self = this;

    nodeMap.data[self.id].value = value;
    listItemRender.call(this, null, function () {
        nodeMap.data[self.id].onclick = function () {
            self.config.value = nodeMap.data[self.id].value;
            window.core.intent({
                action: 'keyboard',
                data: self.config,
                events: {
                    done: function ( event ) {
                        if ( self.saveImmediate ) {
                            if ( typeof self.prepareForSave === 'function' ) {
                                self.prepareForSave.call(self, event.value, function ( error, afterSave ) {
                                    if ( !error ) {
                                        self.saver.call(self, function ( error, done ) {
                                            if ( !error ) {
                                                nodeMap.data[self.id].value = event.value;
                                                if ( typeof afterSave === 'function' ) {
                                                    afterSave.call(self, error);
                                                }
                                            }

                                            if ( typeof done === 'function' ) {
                                                done.call(self, error);
                                            }
                                        });
                                    }
                                });
                            } else {
                                self.saver.call(self, function ( error, done ) {
                                    if ( !error ) {
                                        nodeMap.data[self.id].value = event.value;
                                    }
                                    if ( typeof done === 'function' ) {
                                        done.call(self, error);
                                    }
                                });
                            }
                        } else {
                            nodeMap.data[self.id].listInstance.$nodeChange(event.value !== self.value, self, event.value);
                        }
                    }
                }
            }, function ( error ) {
                console.log(error);
            });
        };
    });

    callback();
};
